window.app = function (app) {

	app.templates = window.appSetup.templates;

	window.appSetup.initConfiguration(app);
	window.appSetup.handlebarsSetup(app);

	app.roleConstructor = window.appSetup.roleConstructor;
	app.applyScript = window.appSetup.$Scripts;

	app.components = window.appSetup.componentsFactory(appComponents);
	app.api = window.appSetup.apiFactory(app);
	app.core = window.appSetup.coreFactory(app);
	app.router = window.appSetup.routerFactory(app);
	app.utils = window.appSetup.utilsFactory(app);

	delete window.appSetup;
	delete window.appComponents;

	return app;

}(app);

window.app.core.init();